export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_BASE_URL;